export default __webpack_public_path__ + "static/media/fac-RD-ban.c3d90cea.jpg";